

















import {Component, Vue} from 'vue-property-decorator';
import BScroll from 'better-scroll';

@Component
export default class TerminalView extends Vue {

  mounted() {
    //取消右键
    document.oncontextmenu = (() => {
      return false;
    });

    new BScroll('#terminal-view', {
      pullUpLoad: true,
      click: true,
      wheel: true,
      scrollbar: true,
    });
  }

}
